import { render, staticRenderFns } from "./edit-event.vue?vue&type=template&id=78b9765c&"
import script from "./edit-event.vue?vue&type=script&lang=js&"
export * from "./edit-event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports